import { useState, useEffect } from 'react';
import { useSearchParams } from 'next/navigation';

const EMBED_QUERY_PARAM = 'embed';

export const isEmbeddedWindow = (): boolean => typeof window !== 'undefined' && window.self !== window.top;

/** Presence check on a raw query string, for callers that need embed state synchronously inside an effect. */
export const hasEmbedQueryParam = (search: string): boolean => new URLSearchParams(search).has(EMBED_QUERY_PARAM);

export const useIsEmbed = () => {
  const searchParams = useSearchParams();
  const [isEmbedWindow, setIsEmbedWindow] = useState(false);

  useEffect(() => {
    setIsEmbedWindow(isEmbeddedWindow());
  }, []);

  const isEmbed = isEmbedWindow || searchParams?.get(EMBED_QUERY_PARAM) != null;

  return { isEmbed };
};
